import React from 'react';

import {getLinkForAdminUI} from 'iss/routes';
import {translate} from 'iss/strings';

function ExtUserPasswordChangeHintPage() {
  return (
    <div>
      <h2>{translate('extUserPasswordChangeHint.title')}</h2>
      <p>{translate('extUserPasswordChangeHint.hint1')} <a id="admin-ui" href={getLinkForAdminUI()}>{translate('extUserPasswordChangeHint.hint2')}</a>.</p>
    </div>
  );
}

export default ExtUserPasswordChangeHintPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/ExtUserPasswordChangeHintPage.jsx